module.exports = __webpack_public_path__ + "img/redBg.803f3f14.png";